import React, { FC, useContext } from 'react';

import { SettingsBlock, SettingsFrame } from 'components';
import { LocalizationContext } from 'localization';
import { SettingsContext } from 'settings';

import { ClientRegister, RegisterWithoutVerifications } from './components';

export const Authorization: FC = () => {
  const { t } = useContext(LocalizationContext);
  const {
    state: {
      settings: { countryCode },
    },
  } = useContext(SettingsContext);

  return (
    <>
      <SettingsBlock title={t('settings.billing.authorization.title')}>
        <SettingsFrame>
          <ClientRegister />
        </SettingsFrame>
        {countryCode !== 'RU' && (
          <SettingsFrame>
            <RegisterWithoutVerifications />
          </SettingsFrame>
        )}
      </SettingsBlock>
    </>
  );
};
